"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GFLeverageSettingProcessor = exports.checkInfoLeverageSettingReason = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const trade_utils_lib_1 = require("trade_utils_lib");
const interfaces_1 = require("./interfaces");
const react_1 = require("react");
const apis_1 = require("./apis");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const useLeverageSettingCheckInfo_1 = require("./useLeverageSettingCheckInfo");
const lodash_1 = require("lodash");
// 获取不允许调整参数的原因
function checkInfoLeverageSettingReason({ reason, $st, }) {
    switch (reason) {
        case interfaces_1.LeverageSettingCheckReason.INVALID_LEVERAGE: {
            return $st("grid_futures_leverage_setting_invalid_leverage");
        }
        case interfaces_1.LeverageSettingCheckReason.DELTA_QUOTE_INVETMENT_TOO_SMALL: {
            return $st("grid_futures_leverage_position_list_error");
        }
        case interfaces_1.LeverageSettingCheckReason.INSUFFICIENT_BALANCE: {
            return $st("available_balance_not_enough");
        }
        default: {
            return "";
        }
    }
}
exports.checkInfoLeverageSettingReason = checkInfoLeverageSettingReason;
const GFLeverageSettingProcessor = (props) => {
    const { curPrice, symbolInfo, exchangeOrder, $st, leverage, orderType } = props;
    const [startLoading, setStartLoading] = (0, react_1.useState)(false);
    const order = exchangeOrder.exchangeGridV4FuturesOrder;
    const { checkInfo, checkError, queryCheckInfo, queryCheckInfoWithParam, loading: checkLoading, } = (0, useLeverageSettingCheckInfo_1.useLeverageSettingCheckInfo)({
        leverage,
        open_price: curPrice,
        orderId: exchangeOrder.id,
    }, orderType, setStartLoading);
    const submit = (0, react_1.useCallback)(() => {
        if (!curPrice) {
            return (0, rxjs_1.throwError)($st("trade_query_ticker_error"));
        }
        return queryCheckInfo().pipe((0, operators_1.mergeMap)((info) => {
            if (info.check_result) {
                return (0, apis_1.leverageSettingAPI)({
                    leverage,
                    orderId: exchangeOrder.id,
                }, orderType);
            }
            const r = checkInfoLeverageSettingReason({ reason: info === null || info === void 0 ? void 0 : info.reason, $st });
            if (r) {
                // 调整杠杆check时肯能出现的错误
                return (0, rxjs_1.throwError)(r);
            }
            return (0, rxjs_1.throwError)({ code: -1, message: "check failed", data: info });
        }));
    }, [$st, curPrice, exchangeOrder.id, orderType, queryCheckInfo, leverage]);
    const submitWithParam = (0, react_1.useCallback)((current_price) => {
        if (!current_price) {
            return (0, rxjs_1.throwError)($st("trade_query_ticker_error"));
        }
        return queryCheckInfoWithParam(current_price).pipe((0, operators_1.mergeMap)((info) => {
            if (info.check_result) {
                return (0, apis_1.leverageSettingAPI)({
                    leverage,
                    orderId: exchangeOrder.id,
                }, orderType);
            }
            const r = checkInfoLeverageSettingReason({ reason: info === null || info === void 0 ? void 0 : info.reason, $st });
            if (r) {
                // 调整杠杆check时肯能出现的错误
                return (0, rxjs_1.throwError)(r);
            }
            return (0, rxjs_1.throwError)({ code: -1, message: "check failed", data: info });
        }));
    }, [$st, exchangeOrder.id, leverage, orderType, queryCheckInfoWithParam]);
    const leverageSettingInfo = (0, react_1.useMemo)(() => {
        if (!checkInfo || !checkInfo.check_result) {
            return undefined;
        }
        const _ratioOrigin = new trade_utils_lib_1.SafeDecimal(order.totalProfit).div(new trade_utils_lib_1.SafeDecimal(order === null || order === void 0 ? void 0 : order.totalCost));
        const _ratioAfterLeverageSetting = new trade_utils_lib_1.SafeDecimal(order.totalProfit).div(new trade_utils_lib_1.SafeDecimal(order === null || order === void 0 ? void 0 : order.totalCost).add(new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.delta_quote_investment)));
        let res = {
            ratioOrigin: _ratioOrigin.toFixed(),
            ratioAfterLeverageSetting: _ratioAfterLeverageSetting.toFixed(),
        };
        return res;
    }, [checkInfo, order === null || order === void 0 ? void 0 : order.totalCost, order.totalProfit]);
    const stopLossRisk = (0, react_1.useMemo)(() => {
        if ((order === null || order === void 0 ? void 0 : order.loss_stop_type) !== TradeAPILib_1.GridStopType.profit_ratio) {
            return false;
        }
        if ((0, lodash_1.isUndefined)(order === null || order === void 0 ? void 0 : order.stop)) {
            return false;
        }
        if (!leverageSettingInfo) {
            return false;
        }
        return new trade_utils_lib_1.SafeDecimal(leverageSettingInfo.ratioAfterLeverageSetting).lte(new trade_utils_lib_1.SafeDecimal(order === null || order === void 0 ? void 0 : order.stop));
    }, [leverageSettingInfo, order === null || order === void 0 ? void 0 : order.loss_stop_type, order === null || order === void 0 ? void 0 : order.stop]);
    const stopProfitRisk = (0, react_1.useMemo)(() => {
        if ((order === null || order === void 0 ? void 0 : order.profit_stop_type) !== TradeAPILib_1.GridStopType.profit_ratio) {
            return false;
        }
        if ((0, lodash_1.isUndefined)(order === null || order === void 0 ? void 0 : order.trailing)) {
            return false;
        }
        if (!leverageSettingInfo) {
            return false;
        }
        return new trade_utils_lib_1.SafeDecimal(leverageSettingInfo.ratioAfterLeverageSetting).gte(new trade_utils_lib_1.SafeDecimal(order === null || order === void 0 ? void 0 : order.trailing));
    }, [leverageSettingInfo, order === null || order === void 0 ? void 0 : order.profit_stop_type, order === null || order === void 0 ? void 0 : order.trailing]);
    const liqRatioInfo = (0, react_1.useMemo)(() => {
        const res = {
            liqUpRatio: undefined,
            liqDownRatio: undefined,
        };
        if (!checkInfo || checkLoading) {
            return res;
        }
        const priceDownAfter = new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_down_after);
        const priceDown = new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_down);
        const priceUpAfter = new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_up_after);
        const priceUp = new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_up);
        const downDiff = priceDownAfter.minus(priceDown);
        const upDiff = priceUpAfter.minus(priceUp);
        const checkAndReturnRatio = (firstV, secondV, diffV) => {
            if (firstV.lte(0) && secondV.lte(0)) {
                return undefined;
            }
            else {
                return diffV.div(firstV).toFixed();
            }
        };
        switch (order.trend) {
            case TradeAPILib_1.GridFuturesTrend.long: {
                res.liqDownRatio = checkAndReturnRatio(priceDown, priceDownAfter, downDiff);
                break;
            }
            case TradeAPILib_1.GridFuturesTrend.short: {
                res.liqUpRatio = checkAndReturnRatio(priceUp, priceUpAfter, upDiff);
                break;
            }
            case TradeAPILib_1.GridFuturesTrend.no_trend: {
                res.liqDownRatio = checkAndReturnRatio(priceDown, priceDownAfter, downDiff);
                res.liqUpRatio = checkAndReturnRatio(priceUp, priceUpAfter, upDiff);
                break;
            }
            default: {
                break;
            }
        }
        return res;
    }, [checkInfo, checkLoading, order.trend]);
    return {
        checkInfo,
        checkLoading,
        submit,
        submitWithParam,
        leverageSettingInfo,
        stopLossRisk,
        stopProfitRisk,
        checkInfoError: checkInfoLeverageSettingReason({ reason: checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reason, $st }),
        checkError,
        liqRatioInfo,
        startLoading,
    };
};
exports.GFLeverageSettingProcessor = GFLeverageSettingProcessor;
